<template>
    <div class="qualitysupervision">
        <div class="header">
            <el-row>
                <el-col :span="6">
                    <label class="headerlabel">用户信息</label>
                    <el-input v-model="param.searchValue" placeholder="请输入用户编号/昵称/手机号码" class="autowidth" clearable></el-input>
                </el-col>
                <el-col :span="6">
                    <label class="headerlabel">处理状态</label>
                    <el-select v-model="param.status" placeholder="请选择" class="autowidth" clearable >
                        <el-option label="未处理" :value="0"></el-option>
                        <el-option label="已处理" :value="1"></el-option>
                    </el-select>
                </el-col>
                <el-col :span="6">
                    <label class="headerlabel">创建时间</label>
                    <el-date-picker
                    v-model="createTime"
                    class="autowidth"
                    clearable
                    type="daterange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    value-format="yyyy-MM-dd" 
                    format="yyyy-MM-dd">
                    </el-date-picker>
                </el-col>
                <el-col :span="6">
                    <el-button type="primary" @click="handleinitialization(1)">筛选</el-button>
                    <el-button @click="recte">重置条件</el-button>
                    <el-button @click="Spotcheck">系统抽查</el-button>
                </el-col>
            </el-row>
        </div>

        <main class="MainContent">
            <el-table
            v-loading="loading"
            element-loading-text="拼命加载中"
            element-loading-spinner="el-icon-loading"
            :data="FeedbackData"
            style="width: 100%">
                <el-table-column prop="feedbackUserID" label="ID"></el-table-column>
                <!-- <el-table-column label="头像">
                    <template slot-scope="scope">
                        <el-avatar :size="24" :src="scope.row.b" ></el-avatar>
                    </template>
                </el-table-column> -->
                <el-table-column prop="feedbackUserName" label="用户昵称"></el-table-column>
                <el-table-column prop="feedbackContent" label="投诉内容"></el-table-column>
                <el-table-column label="处理状态">
                    <template slot-scope="scope">{{ scope.row.status==0?'未处理':'已处理' }}</template>
                </el-table-column>
                <el-table-column prop="handleUserName" label="处理人"></el-table-column>
                <el-table-column prop="phone" label="手机号"></el-table-column>
                <el-table-column prop="handleDate" label="处理时间"></el-table-column>
                <el-table-column label="操作">
                    <template slot-scope="scope">
                        <el-button type="text" style="padding-right: 10px;" @click="LookDetail(scope.row.feedbackKey)">查看</el-button>
                        <el-popconfirm title="是否确定删除？" @confirm="confirm(scope.row.feedbackKey)">
                            <el-button type="text" style="color: #F24B4E;" slot="reference">删除</el-button>
                        </el-popconfirm>
                    </template>
                </el-table-column>
            </el-table>

            <el-pagination
            :hide-on-single-page=true
            @current-change="handleinitialization"
            :current-page.sync="param.pageNum"
            :page-size="param.pageSize"
            layout="total, prev, pager, next"
            :total="param.PageTotal">
            </el-pagination>
        </main>

        <!-- 详情 -->
        <el-dialog
            title="投诉处理"
            :visible.sync="dialogVisible"
            width="480px"
            center
            :before-close="handleClose">
            <div class="dialogcontent">
                <p class="dialogitem">投诉内容：<span>{{ DetailData.feedbackContent }}</span></p>
                <div class="dialogitem">
                    <span>处理结果：</span>
                    <textarea v-model="handleResult"></textarea>
                </div>
                <div style="text-align: center;">
                    <el-button @click="handleClose">关闭</el-button>
                    <el-button type="primary" @click="save">保存</el-button>
                </div>
            </div>
        </el-dialog>

    </div>
</template>
<script>
export default{
    data() {
        return {
            loading:false,
            dialogVisible:false,
            param:{
                searchValue:'',
                status:'',
                params:{
                    startDate:'',
                    endDate:''
                },
                pageNum:1,
                pageSize:10,
                PageTotal:0
            },
            handleResult:'',
            createTime:[],
            DetailData:'',
            FeedbackData: []
        }
    },
    watch:{
        createTime(newval){
            if(newval==null){
                this.param.params.startDate='';
                this.param.params.endDate='';
            }else{
                this.param.params.startDate=newval[0];
                this.param.params.endDate=newval[1];
            }
        }
    },
    mounted() {
        this.init()
    },
    methods: {
        init(){
            this.loading=true;
            this.$Http_Post('/kg/Feedback/list',this.param).then(res=>{
                this.loading=false;
                if(res.Code==0){
                    this.param.PageTotal=res.Counts;
                    this.FeedbackData=res.Data;
                }else{
                    this.$message({type: 'error', message:res.Message});
                }
            })
        },
        handleinitialization(val){
            this.param.pageNum=val;
            this.init();
        },
        handleClose(){
            this.dialogVisible=false;
            this.handleinitialization(1);
        },
        // 查看详情
        LookDetail(e){
            this.$Http_Get('/kg/Feedback/getInfo/'+e).then(res=>{
                if(res.Code==0){
                    this.dialogVisible=true;
                    this.DetailData=res.Data;
                    this.handleResult=this.DetailData.handleResult;
                }else{
                    this.$message({type: 'error', message:res.Message});
                }
            })
        },
        recte(){
            this.param=this.$options.data().param;
            this.handleinitialization(1);
        },
        // 删除
        confirm(id){
            this.$Http_Post('/kg/Feedback/remove/'+id).then(res=>{
                if(res.Code==0){
                    this.$message({type: 'success', message:res.Message});
                    this.init();
                }else{
                    this.$message({type: 'error', message:res.Message});
                }
            });
        },
        // 处理结果
        save(){
            this.$Http_Post('/kg/Feedback/handle',{feedbackKey:this.DetailData.feedbackKey,handleResult:this.handleResult}).then(res=>{
                if(res.Code==0){
                    this.$message({type: 'success', message:res.Message});
                    this.dialogVisible=false;
                    this.handleinitialization(1);
                }else{
                    this.$message({type: 'error', message:res.Message});
                }
            });
        },

        // 系统抽查
        Spotcheck(){
            this.param.status=0;
            this.init();
        }
    },
}
</script>
<style>
.qualitysupervision .header{background: #fff;padding: 20px;}
.qualitysupervision .header .headerlabel{width:90px;display: inline-block;}
.qualitysupervision .header .autowidth{width: 240px;}
.qualitysupervision .MainContent{background: #fff;padding:48px 16px;margin:16px 0;}
.qualitysupervision .dialogcontent{padding: 0 10px;}
.qualitysupervision .dialogcontent .dialogitem{display: flex;margin:0 0 20px;}
.qualitysupervision .dialogcontent .dialogitem textarea{width:320px;height:130px;background: #F0F0F0;border:none;outline: none;padding: 10px;}
</style>